import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { ExpandMoreOutlined } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core";

export default function MuiAutoComplete({
  options,
  label = " ",
  disabled = false,
  placeholder,
  className = "",
  loading,
  heightLimit,
  helperText,
  buttonLabel,
  ...props
}) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const custom_id = `auto-complete-${Date.now()}`;
  return (
    <div className={heightLimit ? "AutoCompleteContainer" : ""}>
      {buttonLabel && (
        <label
          className="input-label"
          htmlFor={custom_id}
          style={{ textAlign: direction === "rtl" ? "right" : "left" }}
        >
          <div className="button-label">
            {label}
            {buttonLabel}
          </div>
        </label>
      )}
      <Autocomplete
        noOptionsText={
          <small className="select-no-option">{t("Nothing_found")}</small>
        }
        {...props}
        disableClearable
        // disablePortal
        disabled={disabled}
        className={disabled ? "autoCompleteInactive" : className}
        options={options || []}
        popupIcon={<ExpandMoreOutlined />}
        size={"small"}
        ListboxProps={{ style: { maxHeight: 250, direction: direction } }}
        loadingText={t("pleaseWait")}
        getOptionLabel={(option) => option?.label ?? ""}
        renderInput={(params) => (
          <TextField
            {...params}
            id={custom_id}
            error={helperText ? true : false}
            helperText={helperText && t("selectOneItem")}
            InputLabelProps={{ shrink: true }}
            label={!buttonLabel && label}
            placeholder={placeholder || t("Nothing_found")}
            variant="outlined"
            size={"small"}
          />
        )}
      />
    </div>
  );
}
